import React from 'react';
import WineCard from '../../../components/WineCard/WindeCard';
import css from './WinesCards.module.css';

const WinesCards = ({ wines, intl }) => {
  return (
    <div className={css.cardWrapper}>
      {wines?.map(wine => (
        <WineCard key={wine?.id.uuid} wine={wine} intl={intl} />
      ))}
    </div>
  );
};

export default WinesCards;
